import { create } from "zustand";
import { fetchLogin } from "./Services/fetchlogin";
import { fetchCreateForm } from "./Services/Form/fetchCreateForm";
import { fetchGetForms } from "./Services/Form/fetchGetForms";
import { fetchCreateUser } from "./Services/Users/fetchCreateUser";

const useStore = create((set) => ({
  loading: false,
  error: null,

  lastFormSaved: null,
  forms: [],
  formsCount: 0,
  lastUserCreated: null,

  resetError: () => set({ error: null }),

  fetchDataLogin: async (body) => {
    set({ loading: true, error: null });
    try {
      await fetchLogin(body);
      set({ loading: false });
    } catch (error) {
      set({ error, loading: false });
    }
  },

  fetchDataCreateForm: async (body) => {
    set({ loading: true, error: null, lastFormSaved: null });
    try {
      const res = await fetchCreateForm(body);
      set({ loading: false, lastFormSaved: res });
      return res;
    } catch (error) {
      set({ error, loading: false });
      throw error;
    }
  },

  // ✅ NUEVO: traer formularios
  fetchDataGetForms: async () => {
    set({ loading: true, error: null });
    try {
      const res = await fetchGetForms();
      const items = res?.data?.items || [];
      const count = res?.data?.count ?? items.length;

      set({ loading: false, forms: items, formsCount: count });
      return res;
    } catch (error) {
      set({ error, loading: false });
      throw error;
    }
  },

  // opcional
  clearForms: () => set({ forms: [], formsCount: 0 }),

  fetchDataCreateUser: async (body) => {
    set({ loading: true, error: null, lastUserCreated: null });
    try {
      const res = await fetchCreateUser(body);
      set({ loading: false, lastUserCreated: res });
      return res;
    } catch (error) {
      set({ error, loading: false });
      throw error;
    }
  },
}));

export default useStore;